import {KeyPair} from '@/types/KeyPair'

export default class UserListCondition {
  page = 1
  totalPages = 1
  totalCount = 0
  sortBy = 'id'
  sortDesc = true
  keyword = ''
  status: -1 | 0 | 1 | 2 = null
  progress_status = ''

  set pagenate(val: KeyPair) {
    this.page = val.current_page || 1
    this.totalPages = val.total_pages || 1
    this.totalCount = val.total_count || 0
  }

  toParams(): KeyPair {
    const sortDesc = (Array.isArray(this.sortDesc) ? this.sortDesc[0] : this.sortDesc) !== false
    const sortBy = Array.isArray(this.sortBy) ? this.sortBy[0] : this.sortBy
    const orders = []
    if (sortBy == 'active') {
      orders.push(`delete_at ${sortDesc ? 'asc' : 'desc'}`)
    }
    if (sortBy != 'id') {
      orders.push(`${sortBy} ${sortDesc ? 'desc' : 'asc'}`)
    }
    orders.push(`id ${sortDesc ? 'desc' : 'asc'}`)

    return {
      page: this.page,
      per_page: 50,
      filter: {
        email_or_name_or_address_cont: this.keyword,
        delete_at_null: (!this.status && this.status !== 0) ? '' : this.status !== -1,
        active_eq: this.status === 1 ? true : this.status === 0 ? false : '',
        progress_status_eq: this.progress_status,
        s: orders
      }
    }
  }
}
